import { useTranslation } from 'react-i18next'

import { PeakHoursWidget } from '../../../../../types/widget/widget'
import { displayFullHour } from '../../../../../utils/dateUtils'
import { createPercentFormatter } from '../../../../../utils/locale/localeUtils'

interface PeakHoursProps {
  report: PeakHoursWidget
  locale: string
}

export const PeakHours = ({ report, locale }: PeakHoursProps) => {
  const { t } = useTranslation('reports')

  const percentFormatter = createPercentFormatter(locale, {
    maximumFractionDigits: 0,
  })

  return (
    <div className="reports-peak-hours-content">
      <div className="reports-peak-chart">
        {report.hours.map(hour => (
          <div
            key={hour.hour}
            className={
              hour.fillRate > 70
                ? 'reports-peak-bar accent'
                : 'reports-peak-bar'
            }
            style={{ height: `${hour.fillRate}%` }}
            title={t('reports.peak-hours.tooltip', {
              hour: displayFullHour(hour.hour),
              value: percentFormatter.format(hour.fillRate / 100),
            })}
          />
        ))}
      </div>

      <div className="reports-peak-summary">
        <div>
          <div className="eyebrow reports-peak-label">
            {t('reports.peak-hours.window')}
          </div>
          <div className="display reports-peak-window">
            {displayFullHour(report.peakWindow.from)} –{' '}
            {displayFullHour(report.peakWindow.to)}
          </div>
        </div>
        <div className="badge badge-accent">
          {t('reports.peak-hours.maximum-fill', {
            value: percentFormatter.format(report.maximumFillRate / 100),
          })}
        </div>
      </div>
    </div>
  )
}
